import { IonIcon, IonInput } from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import React, { useState } from 'react';

interface Props {
  placeholder: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: CustomEvent<FocusEvent>) => void;
  innerRef: React.MutableRefObject<any>;
}

const PasswordInput: React.FC<Props> = (props) => {
  const [seePassword, setSeePassword] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <IonInput
        name={props.name}
        placeholder={props.placeholder}
        type={seePassword ? 'text' : 'password'}
        value={props.value}
        onIonInput={(e) => {
          let value = (e.target as HTMLInputElement).value;
          props.onChange(value);
        }}
        onIonBlur={props.onBlur}
        ref={props.innerRef}
      />
      <button
        tabIndex={-1}
        type="button"
        onClick={() => {
          setSeePassword(!seePassword);
        }}
        style={{
          position: 'absolute',
          top: '50%',
          zIndex: 10,
          right: '15px',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          background: 'transparent'
        }}
      >
        <IonIcon
          slot="icon-only"
          icon={seePassword ? eyeOff : eye}
          size="24"
          style={{ width: '24px', height: '24px', color: '#888' }}
        />
      </button>
    </div>
  );
};

export default PasswordInput;
